import React, { FC, HTMLProps } from 'react';

import Box from '@mui/material/Box';

type Props = HTMLProps<HTMLDivElement> & {
  value: number;
  index: number;
  dismount?: boolean;
};

const TabPanel: FC<Props> = props => {
  const { children, value, index, dismount = true, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {(value === index || !dismount) && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
};

export default TabPanel;
